export default "__VITE_ASSET__947e299c__"